import React from 'react';
import {Route} from 'react-router-dom';
import {Wrapper} from '../hooks/common';
import {Show} from '../hooks/cart/';

export default [
  <Route path="/carts/show/:id" component={props => <Wrapper component={Show} {...props} />} exact key="show" />
];
